import { Action } from 'redux';
import { FILTERS_SET_SHOW_FILTERS_MODAL } from '../../constants/actionTypes';
import { TThunkAction } from '../../types/redux';

export type TSetShowFiltersModal = 'filters/set_show_filters_modal';

export interface ISetShowFiltersModal extends Action<TSetShowFiltersModal> {
  type: TSetShowFiltersModal;
  showFiltersModal: boolean;
}

export function setShowFiltersModal(showFiltersModal: boolean): TThunkAction {
  return dispatch => {
    dispatch<ISetShowFiltersModal>({
      showFiltersModal,
      type: FILTERS_SET_SHOW_FILTERS_MODAL,
    });
  };
}
